import { Link } from 'react-router-dom';

export default function AboutCTA() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <Link
          to="/contact"
          className="inline-block bg-[#C5A55A] text-[#2C2C2C] px-10 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39550] transition-colors whitespace-nowrap cursor-pointer"
        >
          Build With Us
        </Link>
      </div>
    </section>
  );
}